<template>
  <div>
    <page-header style="height: 30px">
      <template v-slot:title><currency class="position-absolute" style="right: 0;" /></template>
    </page-header>
    <page-body>
      <div class="overview-index">
        <a-row :gutter="12">
          <a-col :span="4">
            <money-card
              class="mb-2"
              :title="$t('scope.text_299')"
              :money="todayAmount.today_gross_amount"
              height="122px"
              btnTitle=""
              :showAlert="false"
              :currencyCn="currencyCn" />
            <money-card
              :title="$t('scope.text_300')"
              :money="monthAmount.gross_amount"
              height="122px"
              btnTitle=""
              :showAlert="false"
              :currencyCn="currencyCn" />
          </a-col>
          <a-col :span="4">
            <money-card
              class="mb-2"
              :title="$t('scope.text_301')"
              :money="todayAmount.today_amount"
              height="122px"
              btnTitle=""
              :showAlert="false"
              :currencyCn="currencyCn" />
            <money-card
              :title="$t('scope.text_302')"
              :money="monthAmount.amount"
              height="122px"
              btnTitle=""
              :showAlert="false"
              :currencyCn="currencyCn" />
          </a-col>
          <a-col :span="16">
            <consume-card :header="costHeader" :splitLineShow="true" :seriesArr="dataList" height="198px" :loading="loading" :time-type="activeBtn" :currencySign="currencySign">
              <header-btns slot="header-right" :btns="costBtns" v-model="activeBtn" />
            </consume-card>
          </a-col>
        </a-row>
      </div>
      <vxe-grid
        class="mt-4"
        size="mini"
        border
        :columns="columns"
        :data="billOverviewData" />
    </page-body>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { TIME_SIZE } from '@Bill/constants'
import MoneyCard from '@Bill/sections/MoneyCard'
import HeaderBtns from '@Bill/components/HeaderBtns'
import ConsumeCard from '@Bill/sections/ConsumeCard'
import currencyMixin from '@Bill/mixins/currency'
import currencyRequest from '@Bill/mixins/currencyRequest'
import { getRequestT } from '@/utils/utils'
import { getTimeTableColumn } from '@/utils/common/tableColumn'

export default {
  name: 'ConsumerInfoSidepage',
  components: {
    MoneyCard,
    HeaderBtns,
    ConsumeCard,
  },
  mixins: [currencyMixin, currencyRequest],
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
    getParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      activeBtn: 'month',
      todayAmount: {},
      monthAmount: {},
      dataList: [],
      billOverviewData: [],
      costHeader: {
        title: this.$t('scope.text_303'),
      },
      loading: false,
      costBtns: [
        {
          value: 'month',
          text: this.$t('scope.text_304'),
        },
        {
          value: 'year',
          text: this.$t('scope.text_305'),
        },
      ],
      columns: [
        {
          field: 'month',
          title: this.$t('scope.text_306'),
        },
        {
          field: 'gross_amount',
          title: this.$t('scope.text_307'),
          formatter: ({ cellValue }) => {
            if (this.currencySign === '$') return '$' + cellValue
            return cellValue + '￥'
          },
        },
        {
          field: 'amount',
          title: this.$t('scope.text_308'),
          formatter: ({ cellValue }) => {
            if (this.currencySign === '$') return '$' + cellValue
            return cellValue + '￥'
          },
        },
        {
          field: 'gross_amount',
          title: this.$t('scope.text_309'),
          formatter: ({ row }) => {
            if (this.currencySign === '$') return '$' + (row.gross_amount - row.amount)
            return row.gross_amount - row.amount + '￥'
          },
        },
        getTimeTableColumn({ field: 'updated_time', title: this.$t('scope.text_310'), sortable: true }),
      ],
    }
  },
  computed: {
    ...mapGetters(['scope', 'isAdminMode']),
    ...mapState('app', {
      customer: state => state.customer,
    }),
    computedDate () {
      const end = this.$moment()
      const start = this.$moment().subtract(1, this.activeBtn)
      return {
        start_date: start.format('YYYYMMDD'),
        end_date: end.format('YYYYMMDD'),
        start_date_transform: start.format('YYYY-MM-DD') + 'TZ',
        end_date_transform: end.format('YYYY-MM-DD') + 'TZ',
        data_type: TIME_SIZE[this.activeBtn],
      }
    },
  },
  watch: {
    activeBtn () {
      this.getData()
    },
  },
  created () {
    this.todayAmountM = new this.$Manager('today_amounts')
    this.analysisM = new this.$Manager('bill_analysises', 'v1')
    this.billOverviewM = new this.$Manager('bill_overviews')
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.getTodayAmount()
      this.getMonthAmount()
      this.getData()
      this.getBillOverview()
    },
    async getTodayAmount () {
      try {
        const params = {
          admin: this.isAdminMode,
          scope: this.scope,
          cloudaccount_id: this.data.cloudaccount_id,
          ...this.currencyParams,
        }
        if (this.getParams && this.getParams.entry === 'tenant-manager') {
          params.domain_id = this.data.domain_id
        }
        const { data } = await this.todayAmountM.get({
          id: 'total',
          params,
        })
        this.todayAmount = data
      } catch (error) {
        throw error
      }
    },
    async getMonthAmount () {
      try {
        const { end_date: endDate } = this.computedDate
        const startDateTransform = endDate.substring(0, endDate.length - 2) + '01'
        const params = {
          admin: this.isAdminMode,
          scope: this.scope,
          end_day: endDate,
          start_day: startDateTransform,
          ...this.currencyParams,
        }
        if (this.data.cloudaccount_id) {
          params.filter = [...params.filter, `account_id.equals(${this.data.cloudaccount_id})`]
        }
        if (this.getParams && this.getParams.entry === 'tenant-manager') {
          params.filter = [...params.filter, `domain_id.equals(${this.data.domain_id})`]
        }
        const { data } = await this.billOverviewM.get({
          id: 'total',
          params,
        })
        this.monthAmount = data
      } catch (error) {
        throw error
      }
    },
    async getData () {
      try {
        const { start_date: startDate, end_date: endDate, data_type: dataType } = this.computedDate
        this.dataList = []
        this.loading = true
        const params = {
          start_day: startDate,
          end_day: endDate,
          data_type: dataType,
          admin: this.isAdminMode,
          scope: this.scope,
          $t: getRequestT(),
          padding_field: dataType,
          group: dataType,
          ...this.currencyParams,
        }
        if (this.data.cloudaccount_id) {
          params.filter = [...params.filter, `account_id.equals(${this.data.cloudaccount_id})`]
        }
        if (this.getParams && this.getParams.entry === 'tenant-manager') {
          params.filter = [...params.filter, `domain_id.equals(${this.data.domain_id})`]
        }
        const { data: { data = [] } } = await this.billOverviewM.list({
          params,
        })
        this.dataList = data.map(v => ({
          time: dataType === 'day' ? this.$moment(v.day.toString()).format('YYYY-MM-DD') + 'TZ' : v.month.toString().slice(0, 4) + '-' + v.month.toString().slice(4) + 'TZ',
          value: v.gross_amount,
        }))
        this.dataList.shift()
        this.loading = false
      } catch (error) {
        this.loading = false
        throw error
      }
    },
    async getBillOverview () {
      try {
        this.dataList = []
        this.loading = true
        const params = {
          start_day: this.$moment().subtract(6, 'M').format('YYYYMMDD'),
          end_day: this.$moment().format('YYYYMMDD'),
          group: 'month',
          admin: this.isAdminMode,
          scope: this.scope,
          $t: getRequestT(),
          ...this.currencyParams,
        }
        if (this.data.cloudaccount_id) {
          params.filter = [...params.filter, `account_id.equals(${this.data.cloudaccount_id})`]
        }
        if (this.getParams && this.getParams.entry === 'tenant-manager') {
          params.filter = [...params.filter, `domain_id.equals(${this.data.domain_id})`]
        }
        const { data: { data = [] } } = await this.billOverviewM.list({
          params,
        })
        this.billOverviewData = data
        this.loading = false
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
